import { render, staticRenderFns } from "./PDPEmptyStateCard.vue?vue&type=template&id=f33e2536&scoped=true&"
import script from "./PDPEmptyStateCard.vue?vue&type=script&lang=js&"
export * from "./PDPEmptyStateCard.vue?vue&type=script&lang=js&"
import style0 from "./PDPEmptyStateCard.vue?vue&type=style&index=0&id=f33e2536&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33e2536",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default})
